export default __webpack_public_path__ + "static/media/iptv-delete-icon.9a80901a.svg";